<template lang="pug">
    r-table(
        no-data-text='Sin nota de creditos.'
        no-remove
        no-search
        ref='table'
        remind-key='purchase-credit-note-list'
        v-bind='tableProps' 
        @detail='submitDetail' 
        @remove='submitRemove' 
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { RTable } from '@/components/reusable_components/next'
    //
    import PurchaseCreditNoteModel from '@/models/Purchase/PchPurchaseCreditNote'
    import PurchaseCreditNoteFilters from '@/views/Purchase/PchPurchaseCreditNote/PchPurchaseCreditNoteFilters'
    import PurchaseCreditNoteHeaders from '@/views/Purchase/PchPurchaseCreditNote/PchPurchaseCreditNoteHeaders'
    //
    import TranslatorService from '@/services/translator'
    //
    export default {
        name: 'purchase-credit-note-create',
        components: {
            RTable,
        },
        computed: {

            /**
             *
             */
            ...mapState('SnackbarModalModule', [
                'responseConfirm',
            ]),

            /**
             *
             */
            tableProps() {
                return {
                    filters: PurchaseCreditNoteFilters,
                    headers: PurchaseCreditNoteHeaders,
                    service: PurchaseCreditNoteModel,
                }
            },
        },
        methods: {

            /**
             *
             */
            ...mapActions('MenuesModule', [
                'setItemsTopBar',
                'setTitleTopBar',
            ]),

            /**
             *
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * 
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(PurchaseCreditNoteModel, error.response.data))
            },

            /**
             * 
             */
            refresh() {
                this.$refs.table.refresh()
            },

            /**
             * 
             */
            submitCreate() {
                this.$router.push({ name: 'purchase-credit-note-create' })
            },

            /**
             * 
             */
            submitDetail(event) {
                this.$router.push({ 
                    name: 'purchase-credit-note-update', 
                    params: { 
                        id: event.item.id
                    }
                })
            },

            /**
             * 
             */
            submitRemove(event) {

                //
                this.setWarningSnackbar({
                    title: '¿Esta seguro en eliminar la nota de credito seleccionada?',
                    message: 'Una vez eliminada no se puede recuperar.',
                    confirm: 'eliminar',
                })

                //
                this.selected = event.item
            },

            /**
             * 
             */
            successRemove() {
                this.setSuccessSnackbar('Nota de credito eliminada exitosamente.')
            },

            /**
             * 
             */
            toRemove() {
                this.selected
                    .delete()
                    .then(this.successRemove)
                    .then(this.refresh)
                    .catch(this.error)
            }
        },
        watch: {

            /**
             * 
             */
            responseConfirm(val) {
                switch(val) {
                    case 'eliminar': return this.toRemove()
                }
            }
        },
        mounted() {
            this.setTitleTopBar('Notas de credito')
            this.setItemsTopBar([
                {
                    text: 'agregar nota de credito',
                    icon: 'add_circle',
                    action: this.submitCreate,
                }
            ])
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                //if (!ctx.$can('VIEW_ALL_HOLIDAY')) ctx.$router.push('/')
            })
        },
    }
</script>
